import { isProduction } from "@portal/app/_common/lib/edgeUtils";

/** Mixpanel collects in production only; MIXPANEL_DEBUG opts in a local dev server, never a deployed one. */
export const isMixpanelEnvironment = () =>
  isProduction() || (!!process.env.MIXPANEL_DEBUG && process.env.NODE_ENV === "development");

/** Shared analytics visitor policy: no admins unless allowed, US visitors only. */
export const isEligibleVisitor = ({
  activeRole,
  country,
  allowAdmin = false,
}: {
  activeRole?: string;
  country?: string;
  allowAdmin?: boolean;
}) => (activeRole !== "ADMIN" || allowAdmin) && (!country || country === "US");

/** Shared Mixpanel policy; explicit admin events still obey geography/environment settings. */
export const isTrackableVisitor = (visitor: Parameters<typeof isEligibleVisitor>[0]) =>
  isEligibleVisitor(visitor) && isMixpanelEnvironment();
